import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./common/i18n";
import { StyledEngineProvider } from "@mui/material/styles";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import MomentUtils from "@date-io/moment";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import Store from "./Store";
import { AppSupportProvider } from "./AppSupportProvider";
import "./config/Sentry";

export default () => {
    return (
        <LocalizationProvider utils={MomentUtils} dateAdapter={AdapterDateFns}>
            <StyledEngineProvider injectFirst>
                <I18nextProvider i18n={i18n}>
                    <Store>
                        <AppSupportProvider>
                            <BrowserRouter>
                                {/* <React.StrictMode> */}
                                <MainRoutes />
                                {/* </React.StrictMode> */}
                            </BrowserRouter>
                        </AppSupportProvider>
                    </Store>
                </I18nextProvider>
            </StyledEngineProvider>
        </LocalizationProvider>
    );
};
